// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-selectable-article {
  margin: 0px 0;
  width: 100%;
  background: white;
  border: 1px solid #d9d6cf;
  border-radius: 3px;
  transition: border 200ms linear;
}
.item-selectable-article.selected {
  border-color: var(--ion-color-secondary);
  border-width: 1px;
}

.card-content {
  padding: 0;
  width: 100%;
}

.default-img {
  object-fit: contain !important;
}

.content-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 14px;
  min-height: 78px;
}

.left-section {
  position: relative;
  flex-shrink: 0;
  width: 80px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-selectable-article-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.selected-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: -10px;
  left: -6px;
  z-index: 10;
  border-radius: 50%;
}

.middle-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  line-height: 1.3;
  font-family: AppFontSemiBold;
  word-break: break-word;
  display: flex;
  align-items: center;
  gap: 4px;
}

.option-price {
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-tertiary);
}

.right-section {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.select-button {
  padding: 10px 0;
  background: #f1efea;
  font-size: 14px;
  font-weight: 500;
  font-family: AppFont;
  color: #1d1d1b;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 90px;
  height: 40px;
  white-space: nowrap;
}
.select-button:hover {
  background: #e5e3de;
}
.select-button:active {
  background: #d9d7d2;
}

.item-selectable-article.selected .select-button {
  background: var(--ion-color-secondary);
  font-family: AppFontSemiBold;
  color: #000;
}

app-quantity-selector {
  filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));
}

@media (max-width: 576px) {
  .content-wrapper {
    gap: 12px;
    padding: 10px 12px;
  }
  .left-section {
    width: 60px;
    height: 50px;
  }
  .name {
    font-size: 14px;
  }
  .option-price {
    font-size: 13px;
  }
  .select-button {
    min-width: 75px;
    padding: 8px 16px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-selectable-article/item-selectable-article.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+BAAA;AACD;AACC;EACC,wCAAA;EACA,iBAAA;AACF;;AAGA;EACC,UAAA;EACA,WAAA;AAAD;;AAGA;EACC,8BAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAAD;;AAGA;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAD;;AAGA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAAD;;AAGA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAAD;;AAGA;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AAAD;;AAGA;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAAD;;AAGA;EACC,eAAA;EACA,gBAAA;EACA,gCAAA;AAAD;;AAGA;EACC,cAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAD;AAEC;EACC,mBAAA;AAAF;AAGC;EACC,mBAAA;AADF;;AAKA;EACC,sCAAA;EACA,4BAAA;EACA,WAAA;AAFD;;AAKA;EACC,oDAAA;AAFD;;AAMA;EACC;IACC,SAAA;IACA,kBAAA;EAHA;EAMD;IACC,WAAA;IACA,YAAA;EAJA;EAOD;IACC,eAAA;EALA;EAQD;IACC,eAAA;EANA;EASD;IACC,eAAA;IACA,iBAAA;IACA,eAAA;EAPA;AACF","sourcesContent":[".item-selectable-article {\n\tmargin: 0px 0;\n\twidth: 100%;\n\tbackground: white;\n\tborder: 1px solid #d9d6cf;\n\tborder-radius: 3px;\n\ttransition: border 200ms linear;\n\n\t&.selected {\n\t\tborder-color: var(--ion-color-secondary);\n\t\tborder-width: 1px;\n\t}\n}\n\n.card-content {\n\tpadding: 0;\n\twidth: 100%;\n}\n\n.default-img {\n\tobject-fit: contain !important;\n}\n\n.content-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 12px 16px;\n\tgap: 14px;\n\tmin-height: 78px;\n}\n\n.left-section {\n\tposition: relative;\n\tflex-shrink: 0;\n\twidth: 80px;\n\theight: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.item-selectable-article-image {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.selected-icon {\n\twidth: 24px;\n\theight: 24px;\n\tposition: absolute;\n\ttop: -10px;\n\tleft: -6px;\n\tz-index: 10;\n\tborder-radius: 50%;\n}\n\n.middle-section {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 4px;\n\tmin-width: 0; // Allow text to wrap\n}\n\n.name {\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: #000;\n\tline-height: 1.3;\n\tfont-family: AppFontSemiBold;\n\tword-break: break-word;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 4px;\n}\n\n.option-price {\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: var(--ion-color-tertiary);\n}\n\n.right-section {\n\tflex-shrink: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.select-button {\n\tpadding: 10px 0;\n\tbackground: #f1efea;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tfont-family: AppFont;\n\tcolor: #1d1d1b;\n\tborder-radius: 2px;\n\tcursor: pointer;\n\ttransition: all 0.2s ease;\n\twidth: 90px;\n\theight: 40px;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tbackground: #e5e3de;\n\t}\n\n\t&:active {\n\t\tbackground: #d9d7d2;\n\t}\n}\n\n.item-selectable-article.selected .select-button {\n\tbackground: var(--ion-color-secondary);\n\tfont-family: AppFontSemiBold;\n\tcolor: #000;\n}\n\napp-quantity-selector {\n\tfilter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.1));\n}\n\n// Responsive adjustments for smaller screens\n@media (max-width: 576px) {\n\t.content-wrapper {\n\t\tgap: 12px;\n\t\tpadding: 10px 12px;\n\t}\n\n\t.left-section {\n\t\twidth: 60px;\n\t\theight: 50px;\n\t}\n\n\t.name {\n\t\tfont-size: 14px;\n\t}\n\n\t.option-price {\n\t\tfont-size: 13px;\n\t}\n\n\t.select-button {\n\t\tmin-width: 75px;\n\t\tpadding: 8px 16px;\n\t\tfont-size: 13px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
